const initialState = {
  switches: [],
  alarms: [],
  storages: [],
  modal: {
    title: '',
    description: '',
    type: "",
    id: false,
    display: false
  }
};

export const devices = (state = initialState, action) => {
  switch (action.type) {
    case 'DEVICES_MODAL_CLOSE' : {
      return {
        ...state,
        modal: {
          ...state.modal,
          display: false
        }
      }
    }
    case 'DEVICES_MODAL_RESET' : {
      return {
        ...state,
        modal: initialState.modal
      }
    }
    case 'DEVICES_MODAL_SET' : {
      return {
        ...state,
        modal: action.modal
      }
    }
    case 'SWITCH_BTN': {
      const index = state.switches.findIndex((s) => s.id === action.id);
      if (index === -1) return state;
      let tempArray = JSON.parse(JSON.stringify(state.switches));
      tempArray[index].state = action.value;
      return {
        ...state,
        switches: tempArray
      };
    }
    case 'SWITCH_DELETE': {
      const index = state.switches.findIndex((s) => s.id === action.id);
      if (index === -1) return state;
      let tempArray = JSON.parse(JSON.stringify(state.switches));
      tempArray.splice(index, 1);
      return {
        ...state,
        switches: tempArray
      };
    }
    case 'SET_DEVICES': {
      return {
        ...state,
        ...action.devices
      };
    }
    case 'SWITCH_UPDATE_PART': {
      const index = state.switches.findIndex((s) => s.id === action.id);
      if (index === -1) return state;
      let tempArray = JSON.parse(JSON.stringify(state.switches));
      tempArray[index][action.part] = action.value;
      return {
        ...state,
        switches: tempArray
      };
    }
    case 'SWITCH_ENTER_EDIT': {
      const index = state.switches.findIndex((s) => s.id === action.id);
      if (index === -1) return state;
      let tempArray = JSON.parse(JSON.stringify(state.switches));
      tempArray[index].isEdited = true;
      tempArray[index].edit = {
        name: tempArray[index].name,
        command: tempArray[index].command,
        autoOn: tempArray[index].autoOn,
        isSAM: tempArray[index].isSAM,
        autoOff: tempArray[index].autoOff,
        isAutoNight: tempArray[index].isAutoNight,
        parent: tempArray[index].parent ? tempArray[index].parent : "0",
        isReverted: tempArray[index].isReverted,
        isAutoDay: tempArray[index].isAutoDay,
        isCyclic: tempArray[index].isCyclic
      };
      return {
        ...state,
        switches: tempArray
      }
    }
    case 'SWITCH_CANCEL_EDIT': {
      const index = state.switches.findIndex((s) => s.id === action.id);
      if (index === -1) return state;
      let tempArray = JSON.parse(JSON.stringify(state.switches));
      tempArray[index].isEdited = false;
      return {
        ...state,
        switches: tempArray
      }
    }
    case 'SWITCH_PRE_EDIT': {
      const index = state.switches.findIndex((s) => s.id === action.id);
      if (index === -1) return state;
      let tempArray = JSON.parse(JSON.stringify(state.switches));
      
      const checkObject = action.part.split('.');
      if (checkObject.length > 1) tempArray[index].edit[checkObject[0]][checkObject[1]] = action.value;
      else tempArray[index].edit[action.part] = action.value;
      return {
        ...state,
        switches: tempArray
      }
    }
    case 'SWITCH_EDIT_UPDATE': {
      const index = state.switches.findIndex((s) => s.id === action.id);
      if (index === -1) return state;
      let tempArray = JSON.parse(JSON.stringify(state.switches));
      tempArray[index] = {
        ...tempArray[index],
        name: action.name,
        autoOn: action.autoOn,
        command: action.command,
        isSAM: action.isSAM,
        autoOff: action.autoOff,
        isAutoNight: action.isAutoNight,
        parent: action.parent,
        isAutoDay: action.isAutoDay,
        isReverted: action.isReverted,
        isCyclic: action.isCyclic,
        isEdited: true,
        edit: {
          name: action.name,
          command: action.command,
          autoOn: action.autoOn,
          isSAM: action.isSAM,
          autoOff: action.autoOff,
          isAutoNight: action.isAutoNight,
          parent: action.parent ? action.parent : "0",
          isReverted: action.isReverted,
          isAutoDay: action.isAutoDay,
          isCyclic: action.isCyclic
        }
      }
      return {
        ...state,
        switches: tempArray
      }
    }
    case 'SWITCH_EDIT_RESET': {
      const index = state.switches.findIndex((s) => s.id === action.id);
      if (index === -1) return state;
      let tempArray = JSON.parse(JSON.stringify(state.switches));
      tempArray[index].isEdited = true;
      tempArray[index].edit = {
        name: tempArray[index].name,
        command: tempArray[index].command,
        autoOn: tempArray[index].autoOn,
        isSAM: tempArray[index].isSAM,
        autoOff: tempArray[index].autoOff,
        isAutoNight: tempArray[index].isAutoNight,
        parent: tempArray[index].parent ? tempArray[index].parent : "0",
        isReverted: tempArray[index].isReverted,
        isAutoDay: tempArray[index].isAutoDay,
        isCyclic: tempArray[index].isCyclic
      };
      return {
        ...state,
        switches: tempArray
      }
    }
    case 'ALARM_UPDATE_PART': {
      const index = state.alarms.findIndex((s) => s.id === action.id);
      if (index === -1) return state;
      let tempArray = JSON.parse(JSON.stringify(state.alarms));
      tempArray[index][action.part] = action.value;
      return {
        ...state,
        alarms: tempArray
      };
    }
    case 'ALARM_DELETE': {
      const index = state.alarms.findIndex((s) => s.id === action.id);
      if (index === -1) return state;
      let tempArray = JSON.parse(JSON.stringify(state.alarms));
      tempArray.splice(index, 1);
      return {
        ...state,
        alarms: tempArray
      };
    }
    case 'ALARM_ENTER_EDIT': {
      const index = state.alarms.findIndex((s) => s.id === action.id);
      if (index === -1) return state;
      let tempArray = JSON.parse(JSON.stringify(state.alarms));
      tempArray[index].isEdited = true;
      tempArray[index].edit = {
        name: tempArray[index].name,
        text: tempArray[index].text,
        everyone: tempArray[index].everyone
      };
      return {
        ...state,
        alarms: tempArray
      }
    }
    case 'ALARM_EDIT_RESET': {
      const index = state.alarms.findIndex((s) => s.id === action.id);
      if (index === -1) return state;
      let tempArray = JSON.parse(JSON.stringify(state.alarms));
      tempArray[index].isEdited = true;
      tempArray[index].edit = {
        name: tempArray[index].name,
        text: tempArray[index].text,
        everyone: tempArray[index].everyone
      };
      return {
        ...state,
        alarms: tempArray
      }
    }
    case 'ALARM_CANCEL_EDIT': {
      const index = state.alarms.findIndex((s) => s.id === action.id);
      if (index === -1) return state;
      let tempArray = JSON.parse(JSON.stringify(state.alarms));
      tempArray[index].isEdited = false;
      return {
        ...state,
        alarms: tempArray
      }
    }
    case 'ALARM_PRE_EDIT': {
      const index = state.alarms.findIndex((s) => s.id === action.id);
      if (index === -1) return state;
      let tempArray = JSON.parse(JSON.stringify(state.alarms));
      tempArray[index].edit[action.part] = action.value;
      return {
        ...state,
        alarms: tempArray
      }
    }
    case 'ALARM_EDIT_UPDATE': {
      const index = state.alarms.findIndex((s) => s.id === action.id);
      if (index === -1) return state;
      let tempArray = JSON.parse(JSON.stringify(state.alarms));
      tempArray[index].isEdited = false;
      tempArray[index] = {
        ...tempArray[index],
        name: action.name,
        text: action.text,
        everyone: action.everyone
      }
      return {
        ...state,
        alarms: tempArray
      }
    }
    case 'STORAGE_ENTER_EDIT' : {
      const index = state.storages.findIndex((s) => s.id === action.id);
      if (index === -1) return state;
      let tempArray = JSON.parse(JSON.stringify(state.storages));
      tempArray[index].isEdited = true;
      tempArray[index].edit = {
        name: tempArray[index].name,
        isCalculator: tempArray[index].isCalculator
      };
      return {
        ...state,
        storages: tempArray
      }
    }
    case 'STORAGE_EDIT_RESET': {
      const index = state.storages.findIndex((s) => s.id === action.id);
      if (index === -1) return state;
      let tempArray = JSON.parse(JSON.stringify(state.storages));
      tempArray[index].isEdited = true;
      tempArray[index].edit = {
        name: tempArray[index].name,
        isCalculator: tempArray[index].isCalculator
      };
      return {
        ...state,
        storages: tempArray
      }
    }
    case 'STORAGE_CANCEL_EDIT' : {
      const index = state.storages.findIndex((s) => s.id === action.id);
      if (index === -1) return state;
      let tempArray = JSON.parse(JSON.stringify(state.storages));
      tempArray[index].isEdited = false;
      tempArray[index].edit = false;
      return {
        ...state,
        storages: tempArray
      }
    }
    case 'STORAGE_DELETE': {
      const index = state.storages.findIndex((s) => s.id === action.id);
      if (index === -1) return state;
      let tempArray = JSON.parse(JSON.stringify(state.storages));
      tempArray.splice(index, 1);
      return {
        ...state,
        storages: tempArray
      };
    }
    case 'STORAGE_PRE_EDIT': {
      const index = state.storages.findIndex((s) => s.id === action.id);
      if (index === -1) return state;
      let tempArray = JSON.parse(JSON.stringify(state.storages));
      tempArray[index].edit[action.part] = action.value;
      return {
        ...state,
        storages: tempArray
      }
    }
    case 'STORAGE_EDIT_UPDATE': {
      const index = state.storages.findIndex((s) => s.id === action.id);
      if (index === -1) return state;
      let tempArray = JSON.parse(JSON.stringify(state.storages));
      tempArray[index].name = tempArray[index].edit.name;
      tempArray[index].isCalculator = tempArray[index].edit.isCalculator;
      return {
        ...state,
        storages: tempArray
      }
    }
    case 'STORAGE_MODAL_UPDATE': {
      const index = state.storages.findIndex((s) => s.id === action.id);
      if (index === -1) return state;
      let tempArray = JSON.parse(JSON.stringify(state.storages));
      tempArray[index].name = action.value;
      return {
        ...state,
        storages: tempArray
      };
    }
    default:
      return state;
  }
};
